(function () {
  function initConsent() {
    var notice = document.querySelector('[data-results-consent]');
    if (!notice || notice.dataset.consentReady === 'true') return;
    notice.dataset.consentReady = 'true';

    var openButton = notice.querySelector('[data-results-consent-open]');
    var storageKey = 'evebraResultsClinicalImagesViewed';
    var previouslyViewed = false;

    try {
      previouslyViewed = window.sessionStorage.getItem(storageKey) === 'true';
    } catch (error) {
      previouslyViewed = false;
    }

    function dismissNotice() {
      notice.hidden = true;
      document.documentElement.classList.remove('evebra-results-consent-open');
      try {
        window.sessionStorage.setItem(storageKey, 'true');
      } catch (error) {
        /* The notice still works when session storage is unavailable. */
      }
    }

    if (previouslyViewed) {
      notice.hidden = true;
      return;
    }

    document.documentElement.classList.add('evebra-results-consent-open');
    if (openButton) openButton.addEventListener('click', dismissNotice);
  }

  function initGallery(root) {
    if (!root || root.dataset.resultsReady === 'true') return;
    root.dataset.resultsReady = 'true';

    var modal = root.querySelector('[data-results-modal]');
    if (!modal) return;

    var modalTitle = modal.querySelector('[data-modal-title]');
    var modalBefore = modal.querySelector('[data-modal-before]');
    var modalAfter = modal.querySelector('[data-modal-after]');
    var modalPair = modal.querySelector('[data-modal-pair]');
    var modalCompositeWrap = modal.querySelector('[data-modal-composite-wrap]');
    var modalComposite = modal.querySelector('[data-modal-composite]');
    var closeButton = modal.querySelector('[data-modal-close]');
    var lastTrigger = null;

    function openResult(trigger) {
      lastTrigger = trigger;
      var title = trigger.dataset.title || 'EVEBRA customer result';
      var mode = trigger.dataset.mode || 'pair';
      modalTitle.textContent = title;
      if (mode === 'composite') {
        modalPair.hidden = true;
        modalCompositeWrap.hidden = false;
        modalComposite.src = trigger.dataset.composite;
        modalComposite.alt = trigger.dataset.compositeAlt || title + ' before and after';
      } else {
        modalPair.hidden = false;
        modalCompositeWrap.hidden = true;
        modalBefore.src = trigger.dataset.before;
        modalAfter.src = trigger.dataset.after;
        modalBefore.alt = trigger.dataset.beforeAlt || title + ' before';
        modalAfter.alt = trigger.dataset.afterAlt || title + ' after';
      }
      modal.hidden = false;
      modal.classList.add('is-open');
      document.documentElement.classList.add('evebra-results-modal-open');
      closeButton.focus();
    }

    function closeResult() {
      modal.classList.remove('is-open');
      modal.hidden = true;
      document.documentElement.classList.remove('evebra-results-modal-open');
      modalBefore.removeAttribute('src');
      modalAfter.removeAttribute('src');
      modalComposite.removeAttribute('src');
      if (lastTrigger) lastTrigger.focus();
    }

    root.querySelectorAll('[data-result-open]').forEach(function (button) {
      button.addEventListener('click', function () { openResult(button); });
    });
    closeButton.addEventListener('click', closeResult);
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeResult();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeResult();
    });
  }

  function initAll(scope) {
    initConsent();
    (scope || document).querySelectorAll('[data-evebra-results-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
